import { Components, css, Interpolation, Theme, useTheme } from "@mui/material";

const FacTextFieldRootStyle = () => {
    const theme = useTheme();
    return css`
        & .MuiInputBase-root::before {
            border-color: ${theme?.palette?.primary?.main};
        }

        & .MuiOutlinedInput-notchedOutline {
            border-color: ${theme?.palette?.primary?.main};
        }

        ${theme.palette.mode === "dark" && css`
            & .MuiFormLabel-root.Mui-focused {
                color: ${theme.palette.text.primary};
            }
        `}
    `;
};

const FacTextFieldCleanTransparentStyle: Interpolation<{ theme: Theme }> = ({ theme }) => css`
    & .MuiInputBase-root {
        border-radius: 4px;

        ::before,
        ::after {
            all: unset;
        }
    }

    & .MuiFilledInput-root.Mui-error::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: 0.1rem solid ${theme.palette.error.main};
    }
`;

export const FacTextFieldTheme: Pick<Components<Omit<Theme, "components">>, "FacTextField"> = {
    FacTextField: {
        styleOverrides: {
            root: FacTextFieldRootStyle,
        },
        variants: [
            {
                props: { subVariant: "clean-transparent" },
                style: FacTextFieldCleanTransparentStyle as Interpolation<{ theme: unknown }>,
            },
        ],
    },
};

export default FacTextFieldTheme;
